import { formatExact } from "../lib/money";

/** An offer's own words, as the issuer states them and Wallet captured them. */
export interface OfferTextFields {
  /** How to use it. */
  details?: string | null;
  /** Its terms and conditions. */
  fine_print?: string | null;
  /** The most it pays, where the issuer states a cap apart from the title. */
  max_reward?: number | null;
}

/**
 * How to use an offer, its cap and its terms, without opening the issuer's
 * site. Each behind a disclosure, because terms run to paragraphs and the
 * lists they sit in are long. Renders nothing for an offer with none read.
 */
export function OfferText({ offer }: { offer: OfferTextFields }) {
  const { details, fine_print: finePrint, max_reward: cap } = offer;
  if (!details && !finePrint && !cap) return null;
  return (
    <div className="space-y-1 text-xs text-neutral-400">
      {cap ? <div>Earns at most {formatExact(cap)}</div> : null}
      {details && (
        <details>
          <summary className="cursor-pointer text-neutral-300">How to use it</summary>
          <p className="mt-1 whitespace-pre-line">{details}</p>
        </details>
      )}
      {finePrint && (
        <details>
          <summary className="cursor-pointer text-neutral-500">Terms</summary>
          <p className="mt-1 whitespace-pre-line text-neutral-500">{finePrint}</p>
        </details>
      )}
    </div>
  );
}
